import React, { useEffect, useState } from 'react'
import { createFleetCab } from '../../Services/cabapi/fleetapi'
import CustomInput from '../../Components/Input/CustomInput'
import StyledFileInput from '../../Components/Input/Input'
import DatePicker from '../../Components/Input/DatePicker'
import { toast } from 'react-toastify'
import { SkyButton, SkyOutlinedButton } from '../../Components/Buttons'
import { useNavigate } from 'react-router-dom'
import {
  FIND_ALL_UNIQUE_CAR_BRANDS,
  FIND_CARS_BY_BRAND,
} from '../../Services/cabggl'
import { useQuery } from '@apollo/client'
import Select from '../../Components/Autocompelte/Select'
import { getDecryptedSessionStorageVariable } from '../../utils/encryptStorage'
import sedanImage from '../../Components/Assets/sedan.png'
import suvImage from '../../Components/Assets/suv.png'
import premsuvImage from '../../Components/Assets/prem-suv.png'
const AddCab = () => {
  const todayFormatted = new Date().toISOString().split('T')[0]
  const navigate = useNavigate()
  const fleetId = getDecryptedSessionStorageVariable('fleetId')
  const [errors, setErrors] = useState({})
  const [files, setFiles] = useState({
    rcBook: null,
    permit: null,
    puc: null,
    insurance: null,
  })
  const [formData, setFormData] = useState({
    carOwnerName: '',
    carNo: '',
    color: '',
    variant: '',
    registrationDate: '',
    registrationExpiryDate: '',
    insuranceExpiryDate: '',
    permitExpiryDate: null,
    pucExpiryDate: null,
  })
  const [selectedBrand, setSelectedBrand] = useState([])
  const [carModels, setCarModels] = useState([])
  const [carOptions, setCarOptions] = useState([])
  const { loading, error, data } = useQuery(FIND_ALL_UNIQUE_CAR_BRANDS)
  const { data: modelData } = useQuery(FIND_CARS_BY_BRAND, {
    variables: { brand: selectedBrand?.value },
    skip: !selectedBrand,
  })
  useEffect(() => {
    if (data) {
      const formattedBrands = data.findAllUniqueBrands.map((brand) => ({
        label: brand,
        value: brand,
      }))
      setCarModels(formattedBrands)
    }
  }, [data])

  useEffect(() => {
    if (modelData) {
      const formattedOptions = modelData.findCarsByBrand.map((car) => ({
        label: `${car.brand} - ${car.variant}`,
        value: `${car.brand} - ${car.variant}`,
        carType: car?.carType,
      }))
      setCarOptions(formattedOptions)
    }
  }, [modelData])

  const handleInputChange = (fieldName, text) => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: text,
    }))
  }
  const handleSelectCarAndCartype = (value) => {
    setFormData((prevState) => ({
      ...prevState,
      variant: value?.value,
      carType: value?.carType,
    }))
  }

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] })
  }
  const validateCarDetails = () => {
    const carErrors = {} // To hold errors for the single car detail object

    // Validate the fields of the car detail object
    if (!formData.carOwnerName)
      carErrors.carOwnerName = 'Car owner name is required *'
    if (!files.rcBook) carErrors.rcBook = 'RC Book is required *'
    const carNumberRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/

    if (!formData.carNo) {
      carErrors.carNo = 'Car Number is required*'
    }
    if (!carNumberRegex.test(formData.carNo)) {
      carErrors.carNo = 'Enter valid car number'
    }
    if (formData.carNo.length < 10) {
      carErrors.carNo = 'Enter valid car number'
    }
    if (!files.permit) carErrors.permit = 'Permit is required *'
    if (!files.puc) carErrors.puc = 'PUC is required *'
    if (!files.insurance) carErrors.insurance = 'Insurance is required *'
    if (!formData.color) carErrors.color = 'Car color name is required *'
    if (!formData.variant) carErrors.variant = 'Variant name is required *'
    if (!formData.registrationDate)
      carErrors.registrationDate = 'Registration Date is required *'
    if (!formData.registrationExpiryDate) {
      carErrors.registrationExpiryDate =
        'Registration Expiry Date is required *'
    } else {
      const registrationDate = new Date(formData.registrationDate)
      const registrationExpiryDate = new Date(formData.registrationExpiryDate)
      const diffTime = registrationExpiryDate - registrationDate
      const diffDays = diffTime / (1000 * 3600 * 24)
      const maxDiffDays = 5 * 365.25
      if (diffDays > maxDiffDays) {
        carErrors.registrationExpiryDate = 'Enter valid expiry date'
      }
      if (registrationExpiryDate < registrationDate) {
        carErrors.registrationExpiryDate = 'Enter valid expiry date'
      }
      if (registrationExpiryDate < new Date()) {
        carErrors.registrationExpiryDate = 'Enter valid expiry date'
      }
    }
    if (!formData.insuranceExpiryDate)
      carErrors.insuranceExpiryDate = 'Insurance is required *'
    if (!formData.permitExpiryDate)
      carErrors.permitExpiryDate = 'Permit expiry is required *'
    if (!formData.pucExpiryDate)
      carErrors.pucExpiryDate = 'PUC expiry date is required *'
    // Validate Google location fields
    // if (
    //   !formData?.google_location?.latitude ||
    //   !formData?.google_location?.log ||
    //   !formData?.google_location?.address
    // ) {
    //   carErrors.google_location = 'Google Location is required *'
    // }

    // Check if there are any validation errors
    if (Object.keys(carErrors).length > 0) {
      setErrors(carErrors) // Set the error state
    }

    // Return true if no errors, false otherwise
    return Object.keys(carErrors).length === 0
  }
  let isSubmitting = false
  const handleCabSubmit = async () => {
    // Prevent multiple submissions
    if (isSubmitting) return

    // Set isSubmitting to true to prevent further submissions
    isSubmitting = true

    if (!validateCarDetails()) {
      // Ensure validation is checked again (if needed)
      validateCarDetails()
      isSubmitting = false // Reset the flag
      return
    }

    try {
      const data = new FormData()

      // Append form data
      Object.entries(formData).forEach(([key, value]) => {
        data.append(key, value)
      })
      data.append('fleetOwnerId', fleetId)

      // Append files
      Object.entries(files).forEach(([key, file]) => {
        if (file) {
          data.append(key, file)
        }
      })

      // Make the API call and handle success
      await createFleetCab(data).then((res) => {
        toast.success('Cab registered successfully')
        navigate(-1)
      })
    } catch (error) {
      toast.error('Failed to register cab')
      console.error('error', error)
    } finally {
      // Ensure to reset the flag so submission is allowed again
      isSubmitting = false
    }
  }
  const calculateMinDateRange = () => {
    if (!formData.registrationDate) return null
    const registrationDate = new Date(formData.registrationDate)
    const minDate = registrationDate.toISOString().substr(0, 10)
    return minDate
  }

  const calculateMaxDateRange = () => {
    if (!formData.registrationDate) return null
    const registrationDate = new Date(formData.registrationDate)
    const maxDate = new Date(
      registrationDate.setFullYear(registrationDate.getFullYear() + 5)
    )
      .toISOString()
      .substr(0, 10)

    return maxDate
  }

  return (
    <div className="flex justify-center">
      <div className="bg-white shadow-lg p-4 my-4 w-full sm:w-[90%] ">
        <div className="flex flex-start">
          <SkyOutlinedButton label={'Back'} onClick={() => navigate(-1)} />
        </div>
        <h2 className="text-xl font-bold text-center">Add Cab</h2>
        <div className="mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-start">
            <div>
              <CustomInput
                placeholderValue={'Car Owner'}
                labelValue={'Car Owner Name'}
                required
                name={'carOwnerName'}
                value={formData?.carOwnerName || ''}
                onChange={(text) => {
                  const filteredValue = text.replace(/[^a-zA-Z]/g, '')
                  handleInputChange('carOwnerName', filteredValue)
                }}
              />
              {errors?.carOwnerName && (
                <small className="text-red-500">{errors?.carOwnerName}</small>
              )}
            </div>

            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-full">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Rc Book
                </label>
                <StyledFileInput name={'rcBook'} onChange={handleFileChange} />
                {errors?.rcBook && (
                  <small className="text-red-500">{errors?.rcBook}</small>
                )}
              </div>
            </div>
            <div>
              <CustomInput
                placeholderValue={'MH12AW7890'}
                labelValue={'Car no.'}
                formatCarNumber
                required
                name={`carNo`}
                onChange={(text) => handleInputChange('carNo', text)}
                value={(formData?.carNo).toUpperCase() || ''}
              />
              {errors?.carNo && (
                <small className="text-red-500">{errors?.carNo}</small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-full">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Permit
                </label>
                <StyledFileInput
                  name={'permit'}
                  onChange={handleFileChange}
                  value={formData?.permit}
                />
                {errors?.permit && (
                  <small className="text-red-500">{errors?.permit}</small>
                )}
              </div>
            </div>

            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-full">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  PUC
                </label>
                <StyledFileInput name={'puc'} onChange={handleFileChange} />
                {errors?.puc && (
                  <small className="text-red-500">{errors?.puc}</small>
                )}
              </div>
            </div>
            <div className="flex gap-1 w-full flex-col text-start max-w-full">
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Insurance
              </label>
              <StyledFileInput name={'insurance'} onChange={handleFileChange} />
              {errors?.insurance && (
                <small className="text-red-500">{errors?.insurance}</small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 text-start">
            <div>
              <DatePicker
                labelValue="Registration Date"
                selected={formData?.registrationDate}
                onChange={(value) => {
                  handleInputChange('registrationDate', value)
                }}
                minDate={(() => {
                  const date = new Date()
                  date.setFullYear(date.getFullYear() - 5)
                  return date.toISOString().split('T')[0]
                })()}
                maxDate={new Date().toISOString().split('T')[0]}
              />
              {errors?.registrationDate && (
                <small className="text-red-500">
                  {errors?.registrationDate}
                </small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="Registration Expiry Date"
                selected={formData?.registrationExpiryDate}
                onChange={(value) => {
                  handleInputChange('registrationExpiryDate', value)
                }}
                disable={!formData?.registrationDate}
                maxDate={calculateMaxDateRange()}
                minDate={calculateMinDateRange()}
              />
              {errors?.registrationExpiryDate && (
                <small className="text-red-500">
                  {errors?.registrationExpiryDate}
                </small>
              )}
            </div>

            <div>
              <DatePicker
                labelValue="Insurance Expiry Date"
                selected={formData?.insuranceExpiryDate}
                onChange={(value) => {
                  handleInputChange('insuranceExpiryDate', value)
                }}
                minDate={new Date().toISOString().split('T')[0]}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 1) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.insuranceExpiryDate && (
                <small className="text-red-500">
                  {errors?.insuranceExpiryDate}
                </small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Permit Expiry Date"
                selected={formData?.permitExpiryDate}
                onChange={(value) => {
                  handleInputChange('permitExpiryDate', value)
                }}
                minDate={new Date().toISOString().split('T')[0]}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 2) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.permitExpiryDate && (
                <small className="text-red-500">
                  {errors?.permitExpiryDate}
                </small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="PUC Expiry Date"
                selected={formData?.pucExpiryDate}
                onChange={(value) => {
                  handleInputChange('pucExpiryDate', value)
                }}
                minDate={new Date().toISOString().split('T')[0]}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 1) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.pucExpiryDate && (
                <small className="text-red-500">{errors?.pucExpiryDate}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Color'}
                labelValue={'Color'}
                required
                name={`color`}
                onChange={(text) => handleInputChange('color', text)}
                value={formData?.color || ''}
              />
              {errors?.color && (
                <small className="text-red-500">{errors?.color}</small>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 text-start">
            <div className="flex gap-2">
              <Select
                labelValue={'Select Brand'}
                selected={selectedBrand}
                onSelect={(value) => {
                  setSelectedBrand(value)
                  handleSelectCarAndCartype(null)
                }}
                placeholderValue={'Please select brand'}
                options={carModels}
              />
            </div>
            <div>
              <Select
                labelValue={'Select Model'}
                selected={{
                  label: formData.variant,
                  value: formData.variant,
                }}
                onSelect={(value) => handleSelectCarAndCartype(value)}
                placeholderValue={'Please select model'}
                options={carOptions}
              />
              {errors?.variant && (
                <small className="text-red-500">{errors?.variant}</small>
              )}
            </div>
            <div>
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Car Type - {formData?.carType}
              </label>

              {formData?.carType === 'sedan' && <img src={sedanImage} />}
              {formData?.carType === 'SUV' && <img src={suvImage} />}
              {formData?.carType === 'PREMIUM SUV' && (
                <img src={premsuvImage} />
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start"></div>
        </div>
        <div className=" flex gap-4 my-3">
          <SkyButton label={'Submit'} onClick={handleCabSubmit} />
          <SkyOutlinedButton label={'Cancel'} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  )
}

export default AddCab
